import { AfterViewInit, Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { DeviceService } from '@frontend/vanilla/core';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { RedirectHelperService } from 'packages/sports/web/app/src/navigation-core/redirect-helper.service';

import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';

@Component({
    selector: 'bs-digital-over-ask-maxstake-settings',
    templateUrl: './betslip-over-ask-maxstake-settings.component.html',
    styleUrls: ['./betslip-over-ask-maxstake-settings.component.scss'],
    standalone: false,
})
export class BetSlipOverAskMaxStakeSettingsComponent implements OnInit, AfterViewInit {
    protected readonly logger: SportsRemoteLogger;
    module = EpcotModule.Betslip;
    messages: {
        stakeChangeDesktopBody: SafeHtml;
        stakeChangeMobileBody: SafeHtml;
    };

    @HostBinding('class') className = 'betslip-over-ask-maxstake-settings';

    constructor(
        private redirectHelperService: RedirectHelperService,
        overAskMessagesProvider: OverAskMessagesProvider,
        private elementRef: ElementRef,
        private sanitizer: DomSanitizer,
        protected trackingService: TrackingService,
        public device: DeviceService,
    ) {
        this.messages = {
            stakeChangeDesktopBody: this.sanitizer.bypassSecurityTrustHtml(overAskMessagesProvider.messages.editStakeChangeDesktopUrl),
            stakeChangeMobileBody: this.sanitizer.bypassSecurityTrustHtml(overAskMessagesProvider.messages.editStakeChangeMobileUrl),
        };
    }

    ngOnInit(): void {
        this.trackMaxstake();
    }

    ngAfterViewInit(): void {
        if (this.elementRef.nativeElement.querySelector('#maxstakeSettings')) {
            this.elementRef.nativeElement.querySelector('#maxstakeSettings').addEventListener('click', this.clicked.bind(this), { once: true });
        }
    }

    clicked = (event: Event) => {
        event.preventDefault();
        this.trackLinkClick(event);
        this.redirectHelperService.goToPage((event.currentTarget as HTMLAnchorElement).href);
    };

    private trackMaxstake() {
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betslip',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'overask',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'max Stake previously accepted info',
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    private trackLinkClick(event: Event) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betslip',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'overask',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: 'max Stake previously accepted info',
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'betting settings',
            [trackingConstants.COMPONENT_URL_CLICKED]: (event.currentTarget as HTMLAnchorElement).href,
        });
    }
}
